import { defaultPricingConfig, type PricingConfig } from '../data/pricingConfig';

const KEY = 'im_pricing_overrides_v2';

/**
 * Preview-only persistence of admin edits. In production the versioned config lives in
 * the booking backend and only an authorized admin can publish a new version.
 */
export function loadPricingConfig(): PricingConfig {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return defaultPricingConfig;
    return { ...defaultPricingConfig, ...(JSON.parse(raw) as Partial<PricingConfig>) };
  } catch {
    return defaultPricingConfig;
  }
}

export function savePricingConfig(next: PricingConfig): PricingConfig {
  const bumped: PricingConfig = { ...next, version: bumpVersion(next.version) };
  localStorage.setItem(KEY, JSON.stringify(bumped));
  return bumped;
}

export function resetPricingConfig(): PricingConfig {
  localStorage.removeItem(KEY);
  return defaultPricingConfig;
}

function bumpVersion(v: string): string {
  const m = v.match(/^(.*)\.(\d+)$/);
  return m ? `${m[1]}.${Number(m[2]) + 1}` : `${v}.1`;
}
